import {
  SR_API_ACTION_GET_TENANT_ALERT_APPLICATION,
} from 'api/actionTypes';

export default async function getTenantAlertApplication({ state, apiClient }, { tenantAlertApplicationId }) {
  const tenantAlertApplicationPath = ['household', 'tenantAlertApplicationById', tenantAlertApplicationId];

  if (state.exists(tenantAlertApplicationPath)) {
    return state.get(tenantAlertApplicationPath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_GET_TENANT_ALERT_APPLICATION,
    state: state,
    payload: {
      tenantAlertApplicationId,
    },
    onSuccess(tenantAlertApplication) {
      state.set(tenantAlertApplicationPath, tenantAlertApplication);
    },
  });
}
